import { apiClient } from '../apiClient';

const getTokenHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getCampaignTimelineMarkers = async (params = {}) => {
  try {
    const response = await apiClient.get('/pmiDevices/campaign-timeline-markers', {
      params,
      headers: getTokenHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching campaign timeline markers:', error);
    throw error;
  }
};

export const createCampaignTimelineMarker = async (payload = {}) => {
  try {
    const response = await apiClient.post('/pmiDevices/campaign-timeline-markers', payload, {
      headers: getTokenHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error('Error creating campaign timeline marker:', error);
    throw error;
  }
};

export const updateCampaignTimelineMarker = async (id, payload = {}) => {
  try {
    const response = await apiClient.patch(`/pmiDevices/campaign-timeline-markers/${id}`, payload, {
      headers: getTokenHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error('Error updating campaign timeline marker:', error);
    throw error;
  }
};

export const deleteCampaignTimelineMarker = async (id) => {
  try {
    const response = await apiClient.delete(`/pmiDevices/campaign-timeline-markers/${id}`, {
      headers: getTokenHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting campaign timeline marker:', error);
    throw error;
  }
};
